import React, { FC } from 'react'

import Footer, { FooterProps } from '../../components/Footer'
import { HeaderProps } from '../../components/HeaderBis'

import * as SC from './styled'

export type MainLayoutProps = {
  className?: string
  idContent?: string
  headerProps?: HeaderProps
  footerProps?: FooterProps
  children?: React.ReactNode
  withMobileModal?: boolean
  modals?: React.ReactNode
}

const MainLayout: FC<MainLayoutProps> = ({
  className,
  idContent = 'Content',
  headerProps,
  footerProps,
  children,
  withMobileModal,
  modals,
}) => {
  return (
    <>
      <SC.Layout className={className} id="main-layout">
        {headerProps && <SC.StyledHeader {...headerProps} />}
        <SC.Content id={idContent} $withMobileModal={withMobileModal}>
          {children}
        </SC.Content>
        <SC.Modals>{modals}</SC.Modals>
        {footerProps && <Footer {...footerProps} />}
      </SC.Layout>
    </>
  )
}

export default MainLayout
